<details-card [title]="title | transloco" [description]="description | transloco">
  <div actions>
    <button
      *ngIf="hasProductScopedWords && !hasNoWords && !allWordsHaveProductScope"
      qai-link
      class="header-action"
      [disabled]="hasErrors || isApiRequestInProgress()"
      (click)="onResetToProductDefault()"
    >
      {{ 'simulationBuilder.KEYWORDS_RESET_TO_PRODUCT_DEFAULT' | transloco }}
    </button>
    <button
      *ngIf="!hasNoWords && allWordsHaveProductScope"
      qai-link
      class="header-action"
      [disabled]="isApiRequestInProgress()"
      (click)="onDetachFromProductDefault()"
    >
      {{ 'simulationBuilder.KEYWORDS_DETACH_FROM_PRODUCT_DEFAULT' | transloco }}
    </button>
    <button
      *ngIf="!allWordsHaveProductScope"
      qai-link
      [disabled]="hasErrors || hasNoWords || isApiRequestInProgress()"
      class="header-action"
      (click)="saveAsProductDefault()"
    >
      {{ 'simulationBuilder.KEYWORDS_SAVE_AS_PRODUCT_DEFAULT' | transloco }}
    </button>
  </div>
  <div
    content
    class="content-container"
    *ngIf="replaceWordsPairedFieldsControl"
  >
    <qai-paired-fields
      [formControl]="replaceWordsPairedFieldsControl"
      [fromLabel]="fromLabel | transloco"
      [toLabel]="toLabel | transloco"
      [addFromText]="addFromText | transloco"
      [addNewPairText]="addNewPairText | transloco"
      [getError]="getFieldError"
      [actionsDisabled]="hasErrors || isDeleteInProgress()"
      [deleteActionsDisabled]="isCreateUpdateInProgress()"
      (pairRemoved)="onPairRemoved($event)"
    ></qai-paired-fields>
  </div>
</details-card>

<save-as-product-default-modal
  [open]="saveAsProductDefaultModalOpen"
  [moduleUuid]="moduleUuid"
  [keywordTitle]="keywordTitle | transloco"
  [networkRequestInProgress]="networkRequestInProgress"
  (confirm)="onSaveAsProductDefaultConfirm()"
  (closeModal)="onSaveAsProductDefaultModalClose()"
  (openChange)="saveAsProductDefaultModalOpen = $event"
></save-as-product-default-modal>
